module.exports = __webpack_public_path__ + "img/caisse-d-epargne.00eef2c1.jpg";